import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useParams } from "react-router";
import truncate from "lodash/truncate";
import { PageLayout } from "@components";
import { Tab, Tabs } from "@rentablo/components";
import { useAccountHoldersId } from "@rentablo/api/apiv1";
import { AccountDataForm } from "./components/AccountDataForm";
import { PaymentDataForm } from "./components/PaymentDataForm";

export const CashbackDashboardEditContactPage = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const accountHolderId = Number.parseInt(id!, 10);
  const { data: accountHolder } = useAccountHoldersId(
    { id: accountHolderId },
    { enabled: !!accountHolderId }
  );
  const [naturalPerson] = (accountHolder?.naturalPersons || []).filter(
    (np) => np.isPrimaryAccountHolder
  );

  return (
    <PageLayout
      data-testid="cashback-dashboard-edit-contact"
      isMainPage
      title={
        naturalPerson &&
        `${naturalPerson?.firstName} ${naturalPerson?.lastName}`
      }
      backUrl="/cashback?tab=contacts"
      breadcrumbs={[
        { to: "/", text: t("breadcrumbs.home") },
        {
          to: "/cashback?tab=contacts",
          text: t("domains.cashback.form.breadcrumbs.contacts"),
        },
        {
          text: naturalPerson
            ? truncate(`${naturalPerson?.firstName} ${naturalPerson?.lastName}`)
            : "",
        },
        {
          text: t("domains.cashback.form.breadcrumbs.editContact"),
        },
      ]}
    >
      <Tabs defaultKey="account-details" aria-label="cashback-dashboard-tabs">
        {Boolean(Object.keys(accountHolder || {}).length) && (
          <Tab
            label={t("domains.cashback.form.accountData")}
            key="account-details"
          >
            <Box>
              <AccountDataForm accountHolder={accountHolder!} />
            </Box>
          </Tab>
        )}
        {Boolean(Object.keys(accountHolder || {}).length) && (
          <Tab key="payout-account" label={t("domains.cashback.form.payment")}>
            <Box>
              <PaymentDataForm accountHolder={accountHolder!} />
            </Box>
          </Tab>
        )}
      </Tabs>
    </PageLayout>
  );
};
